module.exports = __webpack_public_path__ + "img/reactiveProgramming.1887deb8.svg";